import { apiClient } from './client'
import type { LessonWordAddResult, LessonWordGroup } from '@/types'

type IndexResponse<T> = {
  data?: T[]
  message?: string
}

type AddResponse = {
  message?: string
  data?: LessonWordAddResult
}

export type LessonWordAddPayload = {
  student_ids?: number[]
  text: string
  translations?: string[]
  tags?: number[]
  type?: 'word' | 'phrase'
  note?: string
}

export const lessonWordsApi = {
  list: async (lessonId: number): Promise<LessonWordGroup[]> => {
    const response = await apiClient.get<IndexResponse<LessonWordGroup>>(`/lessons/${lessonId}/words`)
    return response.data?.data ?? []
  },

  add: async (lessonId: number, payload: LessonWordAddPayload): Promise<LessonWordAddResult & { message?: string }> => {
    const response = await apiClient.post<AddResponse>(`/lessons/${lessonId}/words`, payload)
    return {
      message: response.data?.message,
      created: response.data?.data?.created ?? [],
      skipped: response.data?.data?.skipped ?? [],
    }
  },

  /** Словарь темы программы — в слова урока одним запросом */
  addFromThemeElement: async (lessonId: number, elementId: number): Promise<LessonWordAddResult> => {
    const response = await apiClient.post<AddResponse>(`/lessons/${lessonId}/words/from-theme-element`, {
      element_id: elementId,
    })

    return {
      created: response.data?.data?.created ?? [],
      skipped: response.data?.data?.skipped ?? [],
    }
  },

  removeByWord: async (lessonId: number, wordId: number): Promise<void> => {
    await apiClient.delete(`/lessons/${lessonId}/words/by-word/${wordId}`)
  },
}
